var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error_content"},[_c('img',{attrs:{"src":require("@/assets/images/board.png"),"alt":""}}),_c('button',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }